import React from 'react'
import Button from '@material-ui/core/Button'
import WalidacjaStyle from '../../styles/WalidacjaStyle'
import ButtonSaveFile from '../../components/controls/ButtonSaveFile'
import image from '../../assets/images/szambelan_zalaczniki.svg'
import WalidacjaSuccess from '../WalidacjaSuccess'
import WalidacjaFails from '../WalidacjaFails'
import * as actions from '../../store/actions'
import { connect } from 'react-redux'
import MainStyle from '../../styles/MainStyle'

class Walidacja extends React.Component {
  handleCheckClick = () => {
    const { fileId, onCheckValidity } = this.props
    onCheckValidity(fileId)
  }

  render() {
    const { validityErrors, licencja } = this.props
    return (
      <MainStyle>
        {!validityErrors ? (
          <WalidacjaStyle>
            <img src={image} alt="logo" />
            <h1>Weryfikacja poprawności e-Sprawozdania</h1>
            <h2 className="disabled-headline-5">
              Zanim zapiszesz e-Sprawozdanie do pliku XML, zalecamy sprawdzenie
              poprawności jego wypełnienia
            </h2>
            <h2 className="medium-headline-5">
              UWAGA!!!
              <br /> Sprawdzenie może chwilę potrwać. <br />
              Prosimy cierpliwie poczekać.
            </h2>
            <div>
              <Button
                className="firstButton"
                variant="contained"
                color="primary"
                onClick={this.handleCheckClick}
              >
                SPRAWDŹ POPRAWNOŚĆ
              </Button>
              {(licencja.system !== 'ESPR' || licencja.status === '0') && (
                <ButtonSaveFile variant="outlined" checkValidity={true} />
              )}
            </div>
          </WalidacjaStyle>
        ) : (
          <>
            {validityErrors.length ? (
              <WalidacjaFails errors={validityErrors} />
            ) : (
              <WalidacjaSuccess licencja={licencja} />
            )}
          </>
        )}
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => ({
  fileId: state.sprawozdanie.header.Id,
  validityErrors: state.sprawozdanie.validityErrors,
  licencja: state.sprawozdanie.licencja,
})

const mapDispatchToProps = (dispatch) => ({
  onCheckValidity: (id) => dispatch(actions.checkValidity(id, null)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Walidacja)
